import ProductsTable from "@/app/shared/ecommerce/product/product-list/table";
import ExportButton from "@/app/shared/export-button";
import PageHeader from "@/app/shared/page-header";
import { metaObject } from "@/config/site.config";
import { productsData } from "@/data/products-data";
import routes from "@/routers/routes";
import { PiPlusBold } from "react-icons/pi";
import { Link } from "react-router-dom";
import { Button } from "rizzui";

export const metadata = {
    ...metaObject("Products"),
};

const pageHeader = {
    title: "Products",
    breadcrumb: [
        {
            href: routes.eCommerce.dashboard,
            name: "E-Commerce",
        },
        {
            href: routes.eCommerce.products,
            name: "Products",
        },
        {
            name: "List",
        },
    ],
};

export default function ProductsPage() {
    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            >
                <div className="mt-4 flex items-center gap-3 @lg:mt-0">
                    <ExportButton
                        data={productsData}
                        fileName="product_data"
                        header="ID,Name,Category,Product Thumbnail,SKU,Stock,Price,Status,Rating"
                    />
                    <Link
                        to={routes.eCommerce.createProduct}
                        className="w-full @lg:w-auto"
                    >
                        <Button as="span" className="w-full @lg:w-auto">
                            <PiPlusBold className="me-1.5 h-[17px] w-[17px]" />
                            Add Product
                        </Button>
                    </Link>
                </div>
            </PageHeader>

            <ProductsTable pageSize={10} />
        </>
    );
}
